export default __webpack_public_path__ + "images/header-car.png?6fa67183e98985cf60f5e42cedb020ac";